<template lang="html">

  <div class="wrapper home">

    <slider-home></slider-home>
    <noticias-home></noticias-home>
    <!-- <banner-categorias></banner-categorias> -->
    <banner-quienes-somos></banner-quienes-somos>

  </div>

</template>

<script lang="js">

  import bannerquienesomos from '@/components/parts/banner-quienes-somos';
  import bannercategorias from '@/components/parts/banner-categorias';
  import noticiashome from '@/components/parts/noticias-home';

  import sliderhome from '@/components/parts/slider-home';

  export default {
    name: 'home',
    components : {
      'banner-quienes-somos' : bannerquienesomos,
      'banner-categorias' : bannercategorias,
      'noticias-home' : noticiashome,
      'slider-home' : sliderhome
    }

  }
</script>


<style>


</style>


// WEBPACK FOOTER //
// src/components/views/home.vue